export default __webpack_public_path__ + "static/media/14.23d08599.png";